import { t } from "i18next"
import ValidationsCommon from "../../../../../utils/Validations";
const Validations = () => ({
    ...ValidationsCommon(),
    combinedStickersProductBarcodeCopies: (errors, value) => {
        if (!value) {
            errors.editQ = (t("Required field", {ns: "messages"}));
        } else if (value < 1) {
            errors.editQ = (t("Укажите не менее 1 копии", {ns: "messages"}));
        }
    },
});

export default Validations;